__turbopack_context__.v({
  "dropdown": "OwnerAddressField-module__x8l5xa__dropdown",
  "row": "OwnerAddressField-module__x8l5xa__row",
  "wrap": "OwnerAddressField-module__x8l5xa__wrap",
});
